import React, { FC } from 'react';

import cx from 'classnames';

import { CategoryLabel } from '../../../UI/CategoryLabel';
import { CategoryLabelProps } from '../../../UI/CategoryLabel/CategoryLabel';
import useStyles from './styles';

const CardImageLabelProps: FC<CategoryLabelProps> = (props) => {
  const classes = useStyles();

  return <CategoryLabel {...props} wrapperClass={cx(classes.labelWrapper, props?.wrapperClass)} />;
};

export default CardImageLabelProps;
